module.exports = __webpack_public_path__ + "img/vir.4952d5bf.svg";